import { render, staticRenderFns } from "./survey-initial-cra-apob.vue?vue&type=template&id=0866fb51&scoped=true"
import script from "./survey-initial-cra-apob.vue?vue&type=script&lang=js"
export * from "./survey-initial-cra-apob.vue?vue&type=script&lang=js"
import style0 from "./survey-initial-cra-apob.vue?vue&type=style&index=0&id=0866fb51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0866fb51",
  null
  
)

export default component.exports